import { CAT_STATUSES } from 'App/utils/Collections';

export default {
  category: CAT_STATUSES,
  filters: [],
  searchBarProp: 'name',
};
